import styled from "styled-components"

export const Viewport = styled.div`
  overflow: hidden;

  &.is-draggable {
    cursor: move;
    cursor: grab;
  }

  &.is-dragging {
    cursor: grabbing;
  }
`

export const Track = styled.div`
  display: flex;
  align-items: stretch;
`
